import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function HandoverDialog({ open, onOpenChange, removed = [], targets = [], loads = { here: {}, all: {} }, value, onChange, onConfirm, busy }) {
  const sorted = [...targets].sort((a, b) => (loads.all[a.id] || 0) - (loads.all[b.id] || 0));
  const minLoad = loads.all[sorted[0]?.id] || 0;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FFFFFF] border-[#E4E7EC] max-w-xl" data-testid="handover-dialog">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold">Hand over open tasks</DialogTitle>
          <DialogDescription className="text-neutral-600 text-xs">These people still have unfinished tasks on this project. Choose who takes them over — teammates are listed lightest workload first (open tasks on this project · across all projects).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {removed.map(r => (
            <div key={r.id} className="flex items-center gap-3 rounded-lg border border-[#E4E7EC] p-3" data-testid={`handover-row-${r.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{r.name}</div>
                <div className="text-[11px] font-mono text-neutral-500">{r.count} open task{r.count !== 1 ? "s" : ""}</div>
              </div>
              <Select value={value[r.id] || "none"} onValueChange={v => onChange({ ...value, [r.id]: v === "none" ? "" : v })}>
                <SelectTrigger className="w-64 bg-[#FFFFFF] border-[#E4E7EC]" data-testid={`handover-to-${r.id}`}><SelectValue /></SelectTrigger>
                <SelectContent className="bg-[#FFFFFF] border-[#E4E7EC]">
                  <SelectItem value="none">Leave unassigned</SelectItem>
                  {sorted.map(t => (
                    <SelectItem key={t.id} value={t.id} data-testid={`handover-option-${t.id}`}>
                      <span>{t.name}</span>
                      <span className="ml-2 text-[10px] font-mono text-neutral-500" data-testid={`handover-load-${t.id}`}>{loads.here[t.id] || 0} here · {loads.all[t.id] || 0} total open</span>
                      {(loads.all[t.id] || 0) === minLoad && targets.length > 1 && <span className="ml-2 text-[10px] font-mono text-emerald-600">lightest</span>}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="handover-back">Back</Button>
          <Button onClick={onConfirm} disabled={busy} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid="handover-confirm">
            {busy ? "Saving..." : "Save & hand over"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
